// Local Imports
import { RenderContentBase } from "../base_render";
import { ContentKind } from "../kind";
import { DrawTo } from "../../draw";

// # Graphics — render tier
//
// Graphics content currently draws nothing (its `elements` are a FIXME stub), so
// the render tier is just the content-kind + no-op redraw/recalc. It exists so
// the interaction facade `GraphicsContent` (in `graphics.ts`) has a render object
// to root its entity tree on. DOM-free — no modes/keys/interaction imports.
export class GraphicsRender extends RenderContentBase {
  override readonly contentKind = ContentKind.Graphics;
  override redraw = (_to: DrawTo): unknown => null;
  override recalcBbox = (): void => {};
}
